module.exports = __webpack_public_path__ + "img/green-carpet-grass-06.a26761da.png";